function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/// Formats that apply to a piece of Quill content.

/**
 * A piece of Quill content. Ideally this would be typed more precisely, but
 * we are imitating Quill 1.3.7 typings to ensure interface compatibility.
 *
 * @see isEmbed() to identify embedded content (e.g. images)
 * @see isText() to identify textual content
 */

/**
 * Standalone representation of a Quill DeltaOperation.
 * @see https://github.com/quilljs/delta/blob/master/src/Op.ts
 */
/// Type discriminator for embedded Content.
var isEmbed = function isEmbed(o) {
  return _typeof(o) === 'object' && !!o;
}; /// Type discriminator for textual Content.

var isText = function isText(o) {
  return typeof o === 'string';
};
/**
 * Self-contained piece of Quill content that has been normalized to include
 * all applicable line and character formats and to contain at most one newline
 * (which is guaranteed to be the final character, if present).
 *
 * Chunks compensate for a quirk of the Quill delta format where block-scoped
 * formats (e.g. align, list) apply to an entire line, which may include numerous
 * prior ops; conversely, a single op may contain numerous lines which all carry
 * the same block-scoped format.
 *
 * Chunks also vary from Ops in that they are guaranteed to have an Attributes
 * object.
 */

var TextSpan = /*#__PURE__*/function () {
  function TextSpan(text) {
    _classCallCheck(this, TextSpan);

    _defineProperty(this, "text", void 0);

    _defineProperty(this, "styles", void 0);

    this.styles = [];
    this.text = text;
  }

  _createClass(TextSpan, [{
    key: "toString",
    value: function toString() {
      var style = this.styles.length ? " style=\"".concat(this.styles.join(';'), "\"") : '';
      if (style.length) return "<span".concat(style, ">").concat(this.text, "</span>");else return this.text || '';
    }
  }]);

  return TextSpan;
}();
/**
 * Generator that outputs HTML approximating the visual style of Quill's
 * Parchment formats, but with notable differences:
 *   - the `<div>` tag is used instead of `<p>` for paragraphs
 *   - all styling is inline (no classes; no stylesheet)
 *
 * The resulting HTML is minimal in size, self contained with no need
 * for external stylesheets, minimally influenced by user-agent stylesheets,
 * and looks visually similar to Quill output in modern browsers, although
 * structurally quite different.
 *
 * To achieve this look, the generator applies a style to the `body` element
 * when you `wrap()`, which affects all of the inner content.
 *
 * If you generate fragments, make sure to apply a similar style (especially
 * a `white-space: pre-wrap`) to an enclosing tag, else the HTML will look
 * completely wrong!
 */

var BaseHTML = /*#__PURE__*/function () {
  function BaseHTML(embedFormatters, textFormatters) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        strict = _ref.strict;

    _classCallCheck(this, BaseHTML);

    _defineProperty(this, "embedFormatters", void 0);

    _defineProperty(this, "strict", void 0);

    _defineProperty(this, "textFormatters", void 0);

    this.embedFormatters = embedFormatters;
    this.strict = !!strict;
    this.textFormatters = textFormatters;
  }

  _createClass(BaseHTML, [{
    key: "chunksToLines",
    value: function chunksToLines(chunks) {
      var lines = [];
      var current;

      for (var i = 0; i < chunks.length; i++) {
        var _attributes = chunks[i].attributes;
        var _content = chunks[i].content;
        var newline = false;
        if (isText(_content) && _content.endsWith('\n')) newline = true;
        var text = this.formatChars(_content, _attributes);
        var align = _attributes.align;
        var list = _attributes.list;

        if (current) {
          current.text = current.text + text;

          if (newline) {
            lines.push(current);
            current = undefined;
          }
        } else {
          if (newline) lines.push({
            text: text,
            align: align,
            list: list
          });else current = {
            text: text,
            align: align,
            list: list
          };
        }
      }

      if (current) lines.push(current);
      lines.push({
        text: ''
      });
      return lines;
    }
  }, {
    key: "createTextSpan",
    value: function createTextSpan(text) {
      return new TextSpan(text);
    }
  }, {
    key: "escape",
    value: function escape(text) {
      var repl = function repl(c) {
        return BaseHTML.ESCAPE_CHAR_REPLACEMENTS[c];
      };

      return text.replace(/[<>"&]/g, repl);
    }
  }, {
    key: "formatChars",
    value: function formatChars(content, attributes) {
      var _this = this;

      var text;

      if (isText(content)) {
        text = this.escape(content);
      } else if (isEmbed(content)) {
        var key = Object.keys(content)[0];
        if (this.embedFormatters[key]) text = this.embedFormatters[key](content[key], attributes);else {
          if (this.strict) throw new Error("Unknown embed: ".concat(key));else text = '';
        }
      } else {
        if (this.strict) throw new Error("Unknown insert type: ".concat(_typeof(content)));else text = '';
      }

      var span = this.createTextSpan(text);
      Object.keys(this.textFormatters).forEach(function (k) {
        var attr = attributes[k];
        if (attr) _this.textFormatters[k](span, attr);
      });
      if (this.strict) Object.keys(attributes).forEach(function (k) {
        if (!_this.textFormatters[k]) throw new Error("Unknown attribute: ".concat(k));
      });
      return span.toString();
    }
  }, {
    key: "generate",
    value: function generate(chunks) {
      var _this2 = this;

      var lines = this.chunksToLines(chunks);
      return lines.map(function (line, i) {
        return _this2.formatLine(line, lines[i - 1]);
      }).join('');
    }
  }]);

  return BaseHTML;
}();

_defineProperty(BaseHTML, "ESCAPE_CHAR_REPLACEMENTS", {
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '&': '&amp;'
});

function escapeFontFamily(text) {
  return text.split(/,\s*/).map(function (f) {
    return /\s+/.test(f) && !/^['"].*['"]$/.test(f) ? "'".concat(f, "'") : f;
  }).join(', ');
}

var BODY_STYLE = 'color:#303030;font-weight:400;white-space:pre-wrap;font-family:sans-serif';
/**
 * Inline CSS styles for selected line formats.
 */

var LINE_STYLES = {
  list: 'margin:0px;list-style-position:inside;padding-left:1.5rem'
};
/**
 * HTML generators for non-textual content (e.g. images)
 * in a chunk. Understands width, height and float.
 * @see https://github.com/xeger/quill-image for float support
 */

var EMBEDS = {
  image: function image(src, attributes) {
    var _float = attributes["float"],
        width = attributes.width,
        height = attributes.height;
    var optWidth = width ? " width=\"".concat(width, "\"") : '';
    var optHeight = height ? " height=\"".concat(height, "\"") : '';
    var optStyle = _float ? " style=\"float:".concat(_float, "\"") : '';
    return "<img src=\"".concat(src, "\"").concat(optWidth).concat(optHeight).concat(optStyle, "/>");
  }
};
/**
 * HTML generators for character formats. Line formats are context-sensitive
 * and need to be handled as part of the generation algorithm.
 */

var TEXTS = {
  bold: function bold(span) {
    span.styles.push('font-weight:bold');
  },
  color: function color(span, _color) {
    span.styles.push("color:".concat(_color));
  },
  font: function font(span, _font) {
    if (typeof _font === 'string') span.styles.push("font-family:".concat(escapeFontFamily(_font)));
  },
  italic: function italic(span) {
    span.styles.push('font-style:italic');
  },
  link: function link(span, href) {
    span.text = "<a href=\"".concat(href, "\">").concat(span.text, "</a>");
  },
  size: function size(span, _size) {
    span.styles.push("font-size:".concat(_size));
  },
  underline: function underline(span) {
    span.styles.push('text-decoration:underline');
  }
};
/**
 * Generator that outputs HTML approximating the visual style of Quill's
 * Parchment formats, but with notable differences:
 *   - the `<div>` tag is used instead of `<p>` for paragraphs
 *   - all styling is inline (no classes; no stylesheet)
 *
 * The resulting HTML is minimal in size, self contained with no need
 * for external stylesheets, minimally influenced by user-agent stylesheets,
 * and looks visually similar to Quill output in modern browsers, although
 * structurally quite different.
 *
 * To achieve this look, the generator applies a style to the `body` element
 * when you `wrap()`, which affects all of the inner content.
 *
 * If you generate fragments, make sure to apply a similar style (especially
 * a `white-space: pre-wrap`) to an enclosing tag, else the HTML will look
 * completely wrong!
 */

var MinimalHTML = /*#__PURE__*/function (_BaseHTML) {
  _inherits(MinimalHTML, _BaseHTML);

  var _super = _createSuper(MinimalHTML);

  function MinimalHTML() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MinimalHTML);

    _this = _super.call(this, EMBEDS, TEXTS, options);

    _defineProperty(_assertThisInitialized(_this), "embedFormatters", _objectSpread2({}, EMBEDS));

    _defineProperty(_assertThisInitialized(_this), "textFormatters", _objectSpread2({}, TEXTS));

    return _this;
  }

  _createClass(MinimalHTML, [{
    key: "formatLine",
    value: function formatLine(current, prior) {
      var align = current.align,
          list = current.list,
          text = current.text;
      var style = align ? " style=\"text-align: ".concat(align, "\"") : '';
      var html;
      if (list) html = "<li".concat(style, ">").concat(text, "</li>");else if (text) html = "<div".concat(style, ">").concat(text, "</div>");else html = '';

      if (list !== (prior === null || prior === void 0 ? void 0 : prior.list)) {
        var prefix = [];
        if ((prior === null || prior === void 0 ? void 0 : prior.list) === 'bullet') prefix.push("</ul>");else if ((prior === null || prior === void 0 ? void 0 : prior.list) === 'ordered') prefix.push("</ol>");
        if (list === 'bullet') prefix.push("<ul style=\"".concat(LINE_STYLES.list, "\">"));else if (list === 'ordered') prefix.push("<ol style=\"".concat(LINE_STYLES.list, "\">"));
        html = "".concat(prefix.join('')).concat(html);
      }

      return html;
    }
  }, {
    key: "isLineFormat",
    value: function isLineFormat(format) {
      switch (format) {
        case 'align':
        case 'list':
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "wrap",
    value: function wrap(fragment) {
      return "<!DOCTYPE html><html><body style=\"".concat(BODY_STYLE, "\">").concat(fragment, "</body></html>");
    }
  }]);

  return MinimalHTML;
}(BaseHTML);

/**
 * HTML generators for non-textual content (e.g. images)
 * in a chunk.
 */

var EMBEDS$1 = {
  image: function image(src, attributes) {
    var width = attributes.width,
        height = attributes.height;
    var optWidth = width ? " width=\"".concat(width, "\"") : '';
    var optHeight = height ? " height=\"".concat(height, "\"") : '';
    return "<img src=\"".concat(src, "\"").concat(optWidth).concat(optHeight, "/>");
  }
};
/**
 * HTML generators for character formats. Line formats are context-sensitive
 * and need to be handled as part of the generation algorithm.
 */

var TEXTS$1 = {
  bold: function bold(span) {
    span.styles.push('font-weight:bold');
  },
  color: function color(span, _color) {
    span.styles.push("color:".concat(_color));
  },
  font: function font(span, _font) {
    if (typeof _font === 'string') span.styles.push("font-family:".concat(escapeFontFamily(_font)));
  },
  italic: function italic(span) {
    span.styles.push('font-style:italic');
  },
  link: function link(span, href) {
    span.text = "<a href=\"".concat(href, "\">").concat(span.text, "</a>");
  },
  size: function size(span, _size) {
    span.styles.push("font-size:".concat(_size));
  },
  underline: function underline(span) {
    span.styles.push('text-decoration:underline');
  }
};
/**
 * Generator that outputs HTML approximating the exact HTML output
 * of Quill's Parchment formats. No attempt is made to match the
 * visual appearance of the Quill editor.
 */

var QuillHTML = /*#__PURE__*/function (_BaseHTML) {
  _inherits(QuillHTML, _BaseHTML);

  var _super = _createSuper(QuillHTML);

  function QuillHTML() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, QuillHTML);

    _this = _super.call(this, EMBEDS$1, TEXTS$1, options);

    _defineProperty(_assertThisInitialized(_this), "embedFormatters", _objectSpread2({}, EMBEDS$1));

    _defineProperty(_assertThisInitialized(_this), "textFormatters", _objectSpread2({}, TEXTS$1));

    return _this;
  }

  _createClass(QuillHTML, [{
    key: "formatLine",
    value: function formatLine(current, prior) {
      var align = current.align,
          list = current.list,
          text = current.text;
      var style = align ? " style=\"text-align: ".concat(align, "\"") : '';
      var html;
      if (list) html = "<li".concat(style, ">").concat(text, "</li>");else if (text) {
        if (text === '\n') html = '<br/>';else html = "<p".concat(style, ">").concat(text, "</p>");
      } else html = '';

      if (list !== (prior === null || prior === void 0 ? void 0 : prior.list)) {
        var prefix = [];
        if ((prior === null || prior === void 0 ? void 0 : prior.list) === 'bullet') prefix.push("</ul>");else if ((prior === null || prior === void 0 ? void 0 : prior.list) === 'ordered') prefix.push("</ol>");
        if (list === 'bullet') prefix.push("<ul>");else if (list === 'ordered') prefix.push("<ol>");
        html = "".concat(prefix.join('')).concat(html);
      }

      return html;
    }
  }, {
    key: "isLineFormat",
    value: function isLineFormat(format) {
      switch (format) {
        case 'align':
        case 'list':
          return true;

        default:
          return false;
      }
    }
  }, {
    key: "wrap",
    value: function wrap(fragment) {
      return "<!DOCTYPE html><html><body>".concat(fragment, "</body></html>");
    }
  }]);

  return QuillHTML;
}(BaseHTML);

var Chunk = /*#__PURE__*/function () {
  function Chunk(content, attributes) {
    _classCallCheck(this, Chunk);

    _defineProperty(this, "attributes", void 0);

    _defineProperty(this, "content", void 0);

    this.attributes = attributes ? _objectSpread2({}, attributes) : {};
    this.content = content;
  }

  _createClass(Chunk, [{
    key: "applyLineFrom",
    value: function applyLineFrom(a, g) {
      var _this = this;

      Object.entries(a).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        if (g.isLineFormat(k)) _this.attributes[k] = v;
      });
    }
  }, {
    key: "hasNewline",
    value: function hasNewline() {
      return isText(this.content) && this.content.includes('\n');
    }
  }]);

  return Chunk;
}();

var hasLineFormats = function hasLineFormats(attr, g) {
  return Object.keys(attr).some(g.isLineFormat);
};
/**
 * Convert a Quill delta into an equivalent sequence of Chunk.
 */


function convertOpsToChunks(ops, g) {
  var chunks = [];
  ops.forEach(function (op) {
    if (op.insert === undefined) throw new Error("Unsupported quill-delta Op: ".concat(JSON.stringify(op)));
    var _op$attributes = op.attributes,
        attributes = _op$attributes === void 0 ? {} : _op$attributes;
    var insert = op.insert;

    if (isText(insert)) {
      // Line formats need to be applied to all prior chunks until the last newline.
      if (hasLineFormats(attributes, g)) for (var _i = chunks.length - 1; _i >= 0 && !chunks[_i].hasNewline(); _i--) {
        chunks[_i].applyLineFrom(attributes, g);
      } // This op is broken into single-line chunks for convenience,

      var i = 0;
      var j = insert.indexOf('\n');

      while (i < insert.length && j >= 0) {
        chunks.push(new Chunk(insert.slice(i, j + 1), attributes));
        i = j + 1;
        j = insert.indexOf('\n', j + 1);
      }

      if (i < insert.length) chunks.push(new Chunk(insert.slice(i), attributes));
    } else {
      chunks.push(new Chunk(insert, attributes));
    }
  });
  return chunks;
}

/**
 * Transform Quill Delta operations into a document fragment.
 *
 * @see MinimalHTML for a description of the default generator
 */

function generateFragment(ops) {
  var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new generators.MinimalHTML();
  if (!ops) return '';
  return g.generate(convertOpsToChunks(ops, g));
}
/**
 * Transform Quill Delta operations into a complete document.
 *
 * @see MinimalHTML for a description of the default generator
 */

function generate(ops) {
  var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new generators.MinimalHTML();
  return g.wrap(generateFragment(ops, g));
}
var generators = {
  MinimalHTML: MinimalHTML,
  QuillHTML: QuillHTML
};

export { generate, generateFragment, generators, isEmbed, isText };
